export default __webpack_public_path__ + "static/media/gallery_03.e1f62ea9.jpg";